import { Link, useLocation } from "react-router-dom";

export const Header = () => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-parchment/85 border-b hairline"
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-brand-wordmark"
          className="font-serif text-lg sm:text-xl tracking-tight text-charcoal"
        >
          Findora <span className="text-brass">|</span>{" "}
          <span className="italic">Stylely by Daden</span>
        </Link>
        <nav className="flex items-center gap-5 sm:gap-7 font-mono text-[11px] uppercase tracking-[0.2em] text-[#524F4A]">
          {!isHome && (
            <Link
              data-testid="nav-catalog-link"
              to="/"
              className="hover:text-brass transition-colors duration-200"
            >
              Catalog
            </Link>
          )}
          <Link
            data-testid="nav-about-link"
            to="/about"
            className="hover:text-brass transition-colors duration-200"
          >
            About
          </Link>
          <Link
            data-testid="nav-disclosure-link"
            to="/disclosure"
            className="hover:text-brass transition-colors duration-200"
          >
            Disclosure
          </Link>
          <Link
            data-testid="nav-privacy-link"
            to="/privacy"
            className="hover:text-brass transition-colors duration-200"
          >
            Privacy
          </Link>
        </nav>
      </div>
    </header>
  );
};
